import { Injectable, Injector, Type } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  GuardResult,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { from, Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

type GuardType = Type<CanActivate>;

@Injectable()
export class CompositeGuard implements CanActivate {
  constructor(private injector: Injector) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<GuardResult> {
    const guardTypes = (route.data?.['guards'] ?? []) as GuardType[];

    if (!guardTypes.length) return of(true);

    let result$: Observable<GuardResult> = of(true);

    guardTypes.forEach((guardType) => {
      result$ = result$.pipe(
        switchMap((prevResult) => {
          if (prevResult instanceof UrlTree || prevResult === false) {
            return of(prevResult);
          }

          const guard = this.injector.get<CanActivate>(guardType);
          const result = guard.canActivate(route, state);

          return from(Promise.resolve(result)).pipe(
            switchMap((res) => (res instanceof Observable ? res : of(res))),
          );
        }),
      );
    });

    return result$;
  }
}
